import { render, staticRenderFns } from "./putGzh.vue?vue&type=template&id=dd79918e&scoped=true"
import script from "./putGzh.vue?vue&type=script&lang=js"
export * from "./putGzh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd79918e",
  null
  
)

export default component.exports